(function ($) {
	'use strict';

	var WEAPP = {

		init: function () {
			this.mainMenuBlock();
			this.mainMenuBlock1();
			this.submenuOpener();
			this.fixedHeader();
			this.slidingBorderTabActive();
			this.offerSlider();
			this.newsSlider();
			this.tabSlider();
			this.trainerSlider();
			this.trainerfullSlider();
		},



		mainMenuBlock: function () {
			jQuery('header').on('click', '.navbar-toggle-btn', function (e) {
				e.preventDefault();
				if (!jQuery(this).hasClass("nav-open")) {
					jQuery('#navbar').removeClass('active');
					jQuery('html').removeClass('menu-active');
					jQuery(this).removeClass('nav-close').addClass('nav-open');

				} else {
					jQuery('#navbar').addClass('active');
					jQuery('html').addClass('menu-active');
					jQuery(this).removeClass('nav-open').addClass('nav-close');
				}
			});
		},

		mainMenuBlock1: function () {
			jQuery('header').on('click', '.navbar-toggle-btn.nav-close', function (e) {
				jQuery('html').removeClass('submenu-active');
				jQuery('.nav-item').removeClass('opened');
				jQuery('.submenu-opener').removeClass('closed');
				jQuery('.dropdown-menu').css("display", "none");
			});
		},

		submenuOpener: function () {
			jQuery(".navbar-nav .submenu-opener").on('click', function (e) {
				// e.preventDefault();
				jQuery('html').toggleClass('submenu-active');

				if (!jQuery(this).hasClass('closed')) {
					jQuery(this).addClass('closed');
					jQuery(this).parent('.nav-item').addClass('opened');
					jQuery(this).next('ul.dropdown-menu').slideToggle();
				}
				else {
					jQuery(this).removeClass('closed');
					jQuery(this).parent('.nav-item').removeClass('opened');
					jQuery(this).next('ul.dropdown-menu').slideToggle();
				}

			});

		},



		fixedHeader: function () {
			jQuery(window).scroll(function () {
				var sticky = jQuery('header'),
					scroll = jQuery(window).scrollTop();

				if (scroll >= 30) sticky.addClass('sticky-header');
				else sticky.removeClass('sticky-header');
			});
		},


		slidingBorderTabActive: function () {

			$(document).ready(function () {
				var activePos = $('.tab-wrap li.active').position();

				function changePos() {
					activePos = $('.tab-wrap li.active').position();
					$('.active-border').stop().css({
						left: activePos.left,
						width: $('.tab-wrap li.active').width()
					});
				}
				changePos();
				$('.tab-wrap a').on('click', function (e) {
					e.preventDefault();

					$('.tab-wrap a').stop().parent().removeClass('active');

					$(this).stop().parent().addClass('active');

					changePos();
				});
			});
		},

		offerSlider: function () {

			var swiper = new Swiper(".offer-slider", {
				slidesPerView: 3,
				spaceBetween: 30,
				centeredSlides: false,
				loop: false,
				scrollbar: {
					el: ".offer-swiper-scrollbar",
					draggable: true,
				},
				// navigation: {
				// 	nextEl: ".offer-swiper-button-next",
				// 	prevEl: ".offer-swiper-button-prev",
				// },
				// pagination: {
				// 	el: ".offer-swiper-pagination",
				// 	clickable: true,
				// },
				breakpoints: {
					0: {
						slidesPerView: 1
					},
					768: {
						slidesPerView: 2
					},
					1200: {
						slidesPerView: 3
					}
				}
			});
		},

		newsSlider: function () {

			var swiper = new Swiper(".news-slider", {
				slidesPerView: 3,
				spaceBetween: 30,
				centeredSlides: false,
				loop: false,
				scrollbar: {
					el: ".news-swiper-scrollbar",
					draggable: true,
				},
				// navigation: {
				// 	nextEl: ".news-swiper-button-next",
				// 	prevEl: ".news-swiper-button-prev",
				// },
				// pagination: {
				// 	el: ".news-swiper-pagination",
				// 	clickable: true,
				// },
				breakpoints: {
					0: {
						slidesPerView: 1.1,
						spaceBetween: 15,

					},
					768: {
						slidesPerView: 2.1
					},
					1200: {
						slidesPerView: 3
					}
				}
			});
		},

		tabSlider: function () {

			var swiper = new Swiper(".tab-slider", {
				slidesPerView: 3,
				spaceBetween: 30,
				centeredSlides: false,
				loop: false,
				// scrollbar: {
				// 	el: ".tab-swiper-scrollbar",
				// 	draggable: true,
				// },
				// navigation: {
				// 	nextEl: ".tab-swiper-button-next",
				// 	prevEl: ".tab-swiper-button-prev",
				// },
				// pagination: {
				// 	el: ".tab-swiper-pagination",
				// 	clickable: true,
				// },
				breakpoints: {
					0: {
						slidesPerView: 1.1,

					},
					768: {
						slidesPerView: 1.1
					},
					1200: {
						slidesPerView: 3
					}
				}
			});
		},

		trainerSlider: function () {

			var swiper = new Swiper(".trainer-slider", {
				slidesPerView: 3,
				spaceBetween: 30,
				centeredSlides: false,
				loop: false,
				slidesPerGroup: 3,
				// scrollbar: {
				// 	el: ".trainer-swiper-scrollbar",
				// 	draggable: true,
				// },
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				// pagination: {
				// 	el: ".trainer-swiper-pagination",
				// 	clickable: true,
				// },
				breakpoints: {
					0: {
						slidesPerView: 1.2,
						slidesPerGroup: 1,

						spaceBetween: 15,

					},
					768: {
						slidesPerView: 2.2,
						slidesPerGroup: 2,

					},
					1200: {
						slidesPerView: 3
					}
				}
			});
		},

		trainerfullSlider: function () {

			var swiper = new Swiper(".trainer-full-slider", {
				slidesPerView: 1,
				spaceBetween: 30,
				centeredSlides: false,
				loop: false,
				// scrollbar: {
				// 	el: ".trainer-swiper-scrollbar",
				// 	draggable: true,
				// },
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				// pagination: {
				// 	el: ".trainer-swiper-pagination",
				// 	clickable: true,
				// },
				// breakpoints: {
				// 	0: {
				// 		slidesPerView: 1.2,
				// slidesPerGroup: 1,

				// spaceBetween: 15,

				// 	},
				// 	768: {
				// 		slidesPerView: 2.2,
				// slidesPerGroup: 2,

				// 	},
				// 	1200: {
				// 		slidesPerView: 3
				// 	}
				// }
			});
		},



	};

	WEAPP.init();

})(jQuery);


